import Downshift from 'downshift'

const Select = ({ id, placeholder, items, value, onChange }) => {
    const handleChange = (selectedItem) => {
        onChange(selectedItem.value);
    }

    const itemToString = (item) => {
        return item ? item.label : '';
    }

    const buttonLabel = () => {
        for (let item of items) {
            if (item.value === value) {
                return itemToString(item);
            }
        }

        return placeholder ?? '';
    }

    return (
        <Downshift
            selectedItem={null}
            onChange={handleChange}
            itemToString={itemToString}
        >
            {({
                isOpen,
                getToggleButtonProps,
                getItemProps,
                highlightedIndex
            }) => (
                <div className="vehiclesearch-multiselect" aria-labelledby={null}>
                    <button id={id} className="vehiclesearch-multiselect-button" {...getToggleButtonProps({'aria-label': isOpen ? 'Stäng meny' : 'Öppna meny'})}>
                        {buttonLabel()}
                        <i className="fal fa-angle-down"></i>
                    </button>
                    {isOpen && (
                        <div className="vehiclesearch-multiselect-dropdown">
                        {items?.map((item, index) => (
                            <div
                                className={'vehiclesearch-multiselect-item' + (highlightedIndex === index ? ' highlighted' : '')}
                                {...getItemProps({ key: item.value, index, item })}
                            >
                                 {itemToString(item)}
                            </div>
                        ))}
                        </div>
                    )}
                </div>
            )}
        </Downshift>
    )
}

export default Select
